(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["load-more-script"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    var loadMoreBtn = document.getElementById('LoadMoreProducts');
    if (!loadMoreBtn) return;

    loadMoreBtn.addEventListener('click', function () {
      var nextUrl = loadMoreBtn.getAttribute('data-next-url');
      if (!nextUrl) return;

      loadMoreBtn.disabled = true;
      loadMoreBtn.textContent = 'Loading...';

      fetch(nextUrl)
        .then(function (response) {
          return response.text();
        })
        .then(function (html) {
          // Parse the returned HTML and extract the new products
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var newProducts = doc.querySelectorAll('#CollectionProductGrid li.grid__item');
          debugger;
          var grid = document.getElementById('CollectionProductGrid');
          newProducts.forEach(function (item) {
            grid.appendChild(item);
          });

          // Update or remove the button
          var newButton = doc.getElementById('LoadMoreProducts');
          if (newButton && newButton.getAttribute('data-next-url')) {
            loadMoreBtn.setAttribute('data-next-url', newButton.getAttribute('data-next-url'));
            loadMoreBtn.disabled = false;
            loadMoreBtn.textContent = 'Load More';
          } else {
            loadMoreBtn.remove();
          }
        });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
